import { useFetch } from 'hooks/useFetch'

export const useCasoPermissoesService = () => {
  const fetch = useFetch()

  const listarUsuariosPermitidosDoCaso = async (idCaso) => {
    try {
      const response = await fetch.get(`/casos/${idCaso}/usuarios-permitidos`)
      return response.data || []
    } catch (err) {
      return []
    }
  }

  const adicionarUsuariosPermitidosAoCaso = async (idCaso, idsUsuarios) => {
    try {
      const response = await fetch.postOpen(`/casos/${idCaso}/usuarios-permitidos`, { idsUsuarios })
      return response.data
    } catch (err) {
      return null
    }
  }

  const revogarAcessoAoCaso = async (idCaso, idsUsuarios) => {
    try {
      const response = await fetch.put(`/casos/${idCaso}/usuarios-permitidos`, { idsUsuarios: idsUsuarios })

      return response.data
    } catch (err) {
      return null
    }
  }

  return {
    listarUsuariosPermitidosDoCaso,
    adicionarUsuariosPermitidosAoCaso,
    revogarAcessoAoCaso,
  }
}
